<template>
   <div>
     <Table :columns="d_columns_bill" height="300" border :data="d_data_bill"></Table>
   </div>
</template>

<script>
  import apiBill from '@/api/bill.js';
    export default {
        name: "billT",
        data(){
          return{
            d_columns_bill:[
              {
                title: '账单编号',
                key: 'BillID'
              },
              {
                title: '账单金额',
                key: 'BillMoney',
                render: (h, params) => {
                  return h('span',params.row.BillMoney+' 元')
                }
              },
              {
                title: '所属合同',
                key: 'ContractName'
              },
              {
                title: '所属小项',
                key: 'XiaoXiang'
              },
              {
                title: '金额',
                key: 'Money',
                render: (h, params) => {
                  return h('span',params.row.Money+' 元')
                }
              },
              {
                title: '费用金额',
                key: 'PayMoney',
                render: (h, params) => {
                  return h('span',params.row.PayMoney+' 元')
                }
              },
              {
                title: '税率',
                key: 'TaxRate',
                render: (h, params) => {
                  if('TaxRate' in params.row){
                    return h('span',params.row.TaxRate+'%')
                  }
                }
              },
              {
                title: '缴费日期',
                key: 'PayDay'
              }
            ],
            d_data_bill:[],
          }
        },
      props:{
        ContractID:String,
        billIsRefresh: Boolean
      },
      watch:{
        billIsRefresh(){
          this.pull_data_bill()
        }
      },
      methods:{
        pull_data_bill(){ // data_缴费记录
          console.log('看下pull_data_bill有没有重新加载');
          let params = {
            PageIndex: 1,
            PageSize: 999,
            CondList: [
              {
                Key: 'b.ContractID',
                Operator: "=",
                Value: this.ContractID
              }
            ]
          };
          apiBill.payList.post(params).then((_data) => {
            if(_data.data.ExeSuccess && _data.data.LoginSuccess){
              let requestResult = _data.data.Data;
              let rowsList = requestResult.RowsList;
              this.d_data_bill = rowsList;
            }else {
              this.$Message.error(_data.data.Msg);
            }
          });
        },
      },
      created(){
        let contractInfo = sessionStorage.getItem('contractInfo');
        if(contractInfo){
          this.pull_data_bill();
        }
      }
    }
</script>

<style scoped>

</style>
